<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.grades', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <apexchart
                :type="grades.barGraph.chart.type"
                height="350"
                :series="grades.barGraph.series"
                :options="grades.barGraph"
            />
        </div>

        <AppWell>
            <div class="md:grid md:grid-cols-3 md:gap-6" v-if="trimesters.length">
                <AppCard class="p-4" v-for="trimester in trimesters" :key="trimester.id">
                    <div class="font-semibold">{{ trimester.title }}</div>

                    <div class="mt-5">
                        <div v-if="trimester.links.grades_report">
                            <AppButton :href="trimester.links.grades_report" class="block mt-3">
                                {{ $t('messages.grades_report') }}
                            </AppButton>
                        </div>
                        <div v-if="trimester.links.qualitative_reports">
                            <AppButton :href="trimester.links.qualitative_reports" class="block mt-3">
                                {{ $tc('messages.qualitative_reports', 1) }}
                            </AppButton>
                        </div>
                    </div>
                </AppCard>
            </div>
        </AppWell>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppWell from '@/Shared/AppWell.vue';
import AppCard from '@/Shared/AppCard.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        PanelPage,
        AppWell,
        AppCard,
        AppButton,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'grades', 'trimesters'],
};
</script>
